import React, { useEffect, useState } from "react";
import { get } from '../services/storage.service';
import { useHistory } from "react-router-dom";
import { IonAlert } from '@ionic/react';
//https://ionicframework.com/docs/api/route-redirect
//https://reactrouter.com/web/api/Redirect
/* THIS FILE CHECKS THAT THEY HAVE A LOGIN SET UP
ALSO I'M adding in the universal URL LogUrl 
- so that I can switch to test on our test server. 
*/

const LoginCheck: React.FC = () => {
const LogUrl = "https://www.explorermindsetapp.com"; //prod site
//const LogUrl = "https://expmindapp.wpengine.com"; //testing
const [isvalid, setIsValid] = useState<boolean>(false); //turn to false for ios app. 
const [logvalue,setLog] = useState<string>();
const myhistory = useHistory();

  useEffect(() => {
    get("cred")
    .then(function (finalResult) { //get the user data to authenticate the user
        const userD = JSON.parse(finalResult);
        const check = userD.authtoken;
        //console.log(check !== undefined);
        if(check !== undefined){
            setIsValid(false); //turn on for web version
            setLog(check);
            console.log("setting valid");
        }else{
            setLog(check);
            setIsValid(true);
        }
        console.log(isvalid);
    }).catch(err => {//unable to load the local storage
        console.log("e: " + err.message);
        setIsValid(true);
    });
    }, []);
    function checkIsSent(){
        myhistory.replace('/home');
     }
  
      useEffect(() => {
        console.log(isvalid);
      }, [isvalid]);
    return( 
        <>
        <IonAlert
            isOpen={isvalid}
            onDidDismiss={() => checkIsSent()}
            cssClass="my-login"
            header={"Login error"}
            message={"please try logging in again."}
            buttons={["Back to Login"]}
        />
        </>
    )
};
export default LoginCheck;